<template>
  <v-overlay :value="value">
    <v-sheet
      elevation="12"
      max-width="600"
      rounded="lg"
      width="100%"
      class="pa-4 text-center mx-auto"
      light
    >
      <v-icon class="mb-5" color="success" size="112">mdi-check-circle</v-icon>

      <h2 class="text-h5 mb-6">{{ $t("pages.category_menu.sentence_5") }}</h2>

      <p class="mb-4 text-medium-emphasis text-body-2">
        {{ $t("pages.category_menu.sentence_9") }}
      </p>

      <v-divider class="mb-4"></v-divider>

      <div class="text-end">
        <primary-button @click="$emit('input', false)" block>
          {{ $t("pages.category_menu.sentence_6") }}
        </primary-button>
      </div>
    </v-sheet>
  </v-overlay>
</template>

<script>
export default {
  name: "CategoryMenuGroupSuccessOverlay",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      autoCloseTimerId: null,
    };
  },
  methods: {
    clearAutoCloseTimer() {
      if (!this.autoCloseTimerId) return;
      clearTimeout(this.autoCloseTimerId);
      this.autoCloseTimerId = null;
    },
    startAutoCloseTimer() {
      this.clearAutoCloseTimer();
      this.autoCloseTimerId = setTimeout(() => {
        this.$emit("input", false);
        this.autoCloseTimerId = null;
      }, 2000);
    },
  },
  watch: {
    value(isVisible) {
      if (isVisible) this.startAutoCloseTimer();
      else this.clearAutoCloseTimer();
    },
  },
  beforeDestroy() {
    this.clearAutoCloseTimer();
  },
};
</script>
